import { useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from '@api/ApiEndpoints';
import { useHttpClient } from '@hooks/utils/httpConfig';
import useAuthStore from '@store/authStore';
import { useAuth } from '@auth';

export type FeatureFlags = Record<string, boolean>;

export const useFeatureFlags = (): FeatureFlags => {
  const httpClient = useHttpClient(); // Use the authenticated HTTP client
  const authContext = useAuth(); // Use new auth context
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const tokenWithScope = useAuthStore((s) => s.tokenWithScope);
  const orgToken = typeof window !== 'undefined' ? sessionStorage.getItem('organizationToken') : null;
  
  // Check both new auth context and old auth store for authentication
  const shouldFetch = !!authContext.isAuthenticated || !!isAuthenticated || !!orgToken || !!tokenWithScope;
  
  const { data } = useQuery<FeatureFlags, Error>({
    queryKey: ['featureFlags'],
    queryFn: async () => {      
      // Use the authenticated HTTP client instead of plain fetch
      const data: FeatureFlags = await httpClient.get<FeatureFlags>(API_ENDPOINTS.FEATURE_FLAGS);
      return data;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    enabled: shouldFetch,
  });

  return data || {};
};

export default useFeatureFlags;